import type { BooksHome } from './books-wire';

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * The home, when the answer is one: identity, ladder, catalog, chart and words all present in the
 * shapes the pages read. Anything else is `null`, and the page says so rather than inventing
 * content from a partial answer. Never throws.
 */
export function decodeBooksHome(data: unknown): BooksHome | null {
  if (!isObject(data) || typeof data.org_ref !== 'string') return null;
  const identity = data.identity;
  if (
    !isObject(identity) ||
    typeof identity.legal_name !== 'string' ||
    typeof identity.rule_pack_id !== 'string' ||
    typeof identity.fiscal_year_end_month !== 'number'
  ) {
    return null;
  }
  if (
    !Array.isArray(data.periods) ||
    !Array.isArray(data.statements) ||
    !Array.isArray(data.chart) ||
    !isObject(data.vocabulary)
  ) {
    return null;
  }
  return data as unknown as BooksHome;
}
